<template>
  <v-form @submit.prevent="validate()" ref="form">
    <v-snackbar v-model="snackbar.visibility" :timeout="snackbar.timeout" :color="snackbar.color">
      {{ snackbar.text }}
      <v-btn text @click="remove()" v-show="snackbar.confirm">Confirm</v-btn>
      <v-btn text @click="setSnackbar({ ...snackbar, visibility: false })">{{ snackbar.cancelText }}</v-btn>
    </v-snackbar>
    <v-container grid-list-md>
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="transitStop.name" label="Name" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12" md="6">
          <v-select v-model="transitStop.campus" :items="campuses" item-text="name" item-value="_id" label="Campus" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="transitStop.stopId" label="Stop ID" :rules="[rules.required, rules.number]" append-outer-icon="fa-question" @click:append-outer="openTransitDocs()" />
        </v-col>
        <v-row>
          <v-col>
            <map-input :coordinates.sync="coordinates" :rules="[rules.required]" />
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-btn type="submit" block color="primary">Submit</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import TransitService from '@/services/TransitService'
import rules from '@/mixins/rules'

export default {
  name: 'TransitStopForm',
  mixins: [rules],
  data () {
    return {
      coordinates: [0, 0]
    }
  },
  computed: {
    ...mapGetters([
      'campuses',
      'transitStops',
      'snackbar'
    ]),
    transitStop () {
      const transitStop = this.transitStops.filter((transitStop) => transitStop._id === this.$route.params.id)

      return (transitStop.length) ? transitStop[0] : {}
    }
  },
  watch: {
    transitStop: {
      handler: 'onTransitStopChange'
    },
    coordinates () {
      this.transitStop.lat = this.coordinates[0]
      this.transitStop.lng = this.coordinates[1]
    }
  },
  methods: {
    ...mapMutations([
      'setSnackbar'
    ]),
    async validate () {
      if (this.$refs.form.validate()) {
        try {
          let response
          if (this.$route.params.id) {
            response = await TransitService.updateTransitStop(this.transitStop)
          } else {
            response = await TransitService.addTransitStop(this.transitStop)
          }

          this.setSnackbar({
            ...this.snackbar,
            text: response.data.message,
            color: 'success',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          this.$router.push('/admin/transitstops')
        } catch (e) {
          if (e.response.status === 403) {
            this.$router.push('/login')
          }

          this.setSnackbar({
            ...this.snackbar,
            text: 'Unable to modify transit stop',
            color: 'error',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          console.error(e)
        }
      }
    },
    openTransitDocs () {
      window.open('https://www.metrotransit.org/planner/servicesfinder.aspx', '_blank')
    },
    newCampus () {
      this.$router.push('/admin/campuses/new')
    },
    onTransitStopChange () {
      if (this.transitStop.lat && this.transitStop.lng) {
        this.coordinates = [this.transitStop.lat, this.transitStop.lng]
      }
    }
  }
}
</script>
